export default "/images/fbdc35b7fa010ce8a1c690358fa28d95.avif";